import React from 'react';
import {Image, PageHeader} from 'antd';

const Dark = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Темная тема"
            />
            <p>В приложении реализован выбор темной темы</p>
            <p>Для переключения на темную тему и обратно нужно нажать на иконку настроек в верху справа,<br/>
            и в появившемся drawere использовать переключатель light-dark</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601229818/documentation/Screenshot_2020-09-27_at_20.59.59_xy3x7v.png"
            /><br/><br/>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601229818/documentation/Screenshot_2020-09-27_at_21.00.14_e5wkza.png"
            /><br/><br/>
            <p>В режиме темной темы все компоненты перекрашиваются:</p>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601229819/documentation/Screenshot_2020-09-27_at_21.02.21_dd9poj.png"
            /><br/><br/>
            <p>В работе этой фичи использовалась библиотека react-css-theme-switcher</p>
            <p>А также есть особенности реализации:</p>
            <p>Некоторые компоненты ant design перекрашиваться не хотят,<br/>
                и тогда их нужно добавить в файлы <code>src/theme/dark.less</code> и <code>src/theme/dark.less</code>
            </p>
            <p>Все выбранные пользователем данные, отвечающие за настройки отображения, попадают в редьюсеры и с помощью библиотеки redux-persist записываются пользователю в <code>localStorage</code></p>
            <p>Чтобы добавить редьюсер к сохраняемым в <code>localStorage</code>, нужно в <code>src/redux/store.ts</code> добавить этот редьюсер в persistConfig:</p>
            <code>
                'const persistConfig = &#123;<br/>
                key: 'root',<br/>
                storage,<br/>
                whitelist: ['userPreferences', 'importantColData','hideColumnData'],<br/>
                &#125;
            </code>
        </>
    );
};

export default Dark;